// ======================================================================
// File Name       : SuperUserRegistUpdateContainner.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button, Form } from 'react-bootstrap';
import { MODE } from '../../constants/index';
import { searchSkin, skinEdit, skinInsert } from '../../actions/content/ContentDrillSkinAction';
import ContentDrillSkinCheck from '../../components/content/ContentDrillSkinCheck';
import ContentDrillSkinRegisterUpdate from '../../components/content/ContentDrillSkinRegisterUpdate';
import { CONTENT_DRILL_SKIN_LIST } from '../../constants/PathConstants';
import { SKIN_SECERN_ID_DEFAULT } from '../../constants/ContentConstant';
import { showLoading, hideLoading } from '../../utils/PageUtils';
import Header from '../../components/Header';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class ContentDrillSkinRegistUpdateContainner extends Component {
  constructor() {
    super();
    this.state = {
      mode: MODE.NEW_MODE,
      skinSetInfo: {},
      showCheck: false,
      fileUpload: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.showCheckDlg = this.showCheckDlg.bind(this);
    this.okCheckDlg = this.okCheckDlg.bind(this);
    this.cancelCheckDlg = this.cancelCheckDlg.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (match.params.id) {
      const skinSetSecernId = match.params.id;
      if (SKIN_SECERN_ID_DEFAULT.indexOf(skinSetSecernId) > -1) {
        this.props.history.push(CONTENT_DRILL_SKIN_LIST);
      } else {
        this.setState({ skinSetSecernId }, () => {
          this.getSkinList(skinSetSecernId);
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { skinSetSecernId } = this.state;
    const { content } = nextProps;
    const { skinListResult } = content;
    const skinSetInfo =
      skinListResult && $.grep(skinListResult.skinList, e => e.skinSetSecernId === skinSetSecernId);
    if (skinSetSecernId) {
      if (skinSetInfo && skinSetInfo.length > 0) {
        this.setState({
          mode: MODE.EDIT_MODE,
          skinSetInfo: skinSetInfo[0],
        });
      } else {
        this.props.history.push(CONTENT_DRILL_SKIN_LIST);
      }
    }
  }

  /**
   * Get skin list
   *
   */
  getSkinList(skinSetSecernId) {
    const param = {
      skinSetSecernId,
    };
    this.props.dispatch(searchSkin(param));
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    const skinSetInfo = { ...this.state.skinSetInfo, ...{ [name]: value } };
    this.setState({
      skinSetInfo,
    });
  }

  handleFileChange(event) {
    if (event.target.files.length !== 0) {
      const fileName = event.target.files[0].name;
      const skinSetInfo = { ...this.state.skinSetInfo, ...{ skinSetZipFileName: fileName } };
      this.setState({
        fileUpload: event.target.files[0],
        skinSetInfo,
      });
    }
  }

  backPage() {
    this.props.history.goBack();
  }

  /**
   * Show check dialog
   */
  showCheckDlg() {
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
    if (isValid) {
      this.setState({ showCheck: true });
    }
  }

  /**
   * Handle event when click on キャンセル of check dialog
   *
   */
  cancelCheckDlg() {
    this.setState({ showCheck: false });
  }

  /**
   * Handle event when click on OK of check dialog
   *
   */
  okCheckDlg() {
    const { mode, skinSetInfo, fileUpload } = this.state;
    const param = {
      skinSetSecernId: skinSetInfo.skinSetSecernId || undefined,
      skinSetName: skinSetInfo.skinSetName || undefined,
    };
    if (fileUpload) {
      param.skinSetZipFileName = skinSetInfo.skinSetZipFileName || undefined;
      param.skinZipFile = fileUpload;
    }
    this.props.dispatch(showLoading());
    if (mode === MODE.NEW_MODE) {
      this.props.dispatch(skinInsert(param, this.props.history));
    } else {
      this.props.dispatch(skinEdit(param, this.props.history));
    }
    this.setState({ showCheck: false });
  }

  render() {
    const { mode } = this.state;
    this.refsToValidate = [];
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DRILL_SKIN_LIST}
          text="スキン一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name={mode === MODE.EDIT_MODE ? 'スキン情報の編集' : 'スキン情報の新規登録'}/>
        <p className="margin-top-10">登録する内容を指定してください</p>
        <ContentDrillSkinRegisterUpdate
          {...this.state}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          handleChange={this.handleInputChange}
          handleFileChange={this.handleFileChange}
          handleSubmit={this.showCheckDlg.bind(this)}
        />
        <Form.Group className="margin-top-20 text-center">
          <Col sm={12} className="text-center">
            {mode === MODE.EDIT_MODE &&
              <Button variant="default" className="margin-10 btn-96" onClick={this.backPage.bind(this)}>
                キャンセル
              </Button>}
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.showCheckDlg.bind(this)}
            >
              OK
            </Button>
          </Col>
        </Form.Group>
        <ContentDrillSkinCheck
          {...this.state}
          onCancel={this.cancelCheckDlg}
          onOK={this.okCheckDlg}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ content: state.content },
});

export default connect(mapStateToProps)(ContentDrillSkinRegistUpdateContainner);
